import { create } from 'zustand';
import { User } from '../types';
import { authApi } from '../api/auth';
import { mixpanel, track, EVENTS } from '../lib/mixpanel';
import { getPortalUrl, clearDevPortalOverride } from '../lib/portal';

interface AuthState {
  user: User | null;
  loading: boolean;
  initialized: boolean;
  setUser: (user: User | null) => void;
  fetchMe: () => Promise<void>;
  logout: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  loading: false,
  initialized: false,

  setUser: (user) => set({ user }),

  fetchMe: async () => {
    set({ loading: true });
    try {
      const user = await authApi.getMe();
      mixpanel.identify(user._id);
      mixpanel.people.set({
        $email: user.email,
        $name: user.name,
        beta_approved: user.betaApproved ?? false,
        is_owner: user.isOwner ?? false,
      });
      track(EVENTS.SESSION_RESTORED, { user_id: user._id, email: user.email });
      set({ user, loading: false, initialized: true });
    } catch {
      set({ user: null, loading: false, initialized: true });
    }
  },

  logout: async () => {
    try {
      await authApi.logout();
    } finally {
      track(EVENTS.LOGOUT);
      mixpanel.reset();
      clearDevPortalOverride();
      set({ user: null });
      window.location.href = getPortalUrl('viewer');
    }
  },
}));
